import React from 'react';
import S from './NavLink.styled';
import { ILink } from '@/src/types';
import { Icon } from '@/components/global';
import { TextButtonLabel } from '@/styles/typography';

export interface ILinkBlok {
  label?: string;
  link?: ILink;
}

export interface ILinkProps {
  blok: ILinkBlok;
  color?: string;
  size?: string;
  chevronRight?: boolean;
  orangeHover?: boolean;
  onClick?: () => void;
  onMouseOver?: () => void;
  disabled?: boolean;
  active?: boolean;
  margin?: string | number;
  width?: string | number;
  weight?: number;
  tabIndex?: number;
}

const NavLink: React.FC<ILinkProps> = ({
  blok: { label, link },
  color,
  size,
  chevronRight,
  orangeHover,
  onClick,
  onMouseOver,
  disabled,
  active,
  margin,
  weight,
  width,
  tabIndex,
}) => {
  const commonProps = {
    $disabled: disabled,
    $margin: margin,
    $width: width,
    $chevronRight: chevronRight,
    $orangeHover: orangeHover,
  };

  const renderContent = (
    <>
      <TextButtonLabel
        $color={active ? 'orangePeel' : color || 'black'}
        $size={size}
        $weight={weight}
      >
        {label}
      </TextButtonLabel>
      {chevronRight && (
        <Icon
          src="ChevronRight"
          width={14}
          color={color || 'black'}
          margin="0 0 0 10px"
        />
      )}
    </>
  );

  if (link && link.url)
    return (
      <S.ExternalLink
        href={link.url}
        target={link.target}
        {...commonProps}
        tabIndex={tabIndex}
      >
        {renderContent}
      </S.ExternalLink>
    );

  if (link && link.cached_url)
    return (
      <S.InternalLink
        to={`/${link.cached_url.replace(/^\//, '')}`}
        target={link.target}
        {...commonProps}
        tabIndex={tabIndex}
      >
        {renderContent}
      </S.InternalLink>
    );

  if (onClick)
    return (
      <S.Button onClick={onClick} {...commonProps} tabIndex={tabIndex}>
        {renderContent}
      </S.Button>
    );

  if (onMouseOver)
    return (
      <S.Button onMouseOver={onMouseOver} {...commonProps} tabIndex={tabIndex}>
        {renderContent}
      </S.Button>
    );

  return null;
};

export default NavLink;
